/* ===== Sticky Header: Smart Hide/Show + Transparent-Until-Scroll ===== */
(() => {
  if (window.Shopify && Shopify.designMode) return; // Skip in Theme Editor

  const header =
    document.querySelector('[data-header]') ||
    document.querySelector('header.header') ||
    document.querySelector('.site-header');

  if (!header) return;

  let lastY = window.scrollY;
  let ticking = false;
  const threshold = 10;   // min delta before reacting
  const compactAt = 120;  // when to add compact style

  function applyState(y, fromInit = false) {
    // Top state (transparent background)
    if (y <= 4) {
      header.classList.add('header--at-top');
    } else {
      header.classList.remove('header--at-top');
    }

    // Hide on scroll down (after 100px), show on scroll up
    if (!fromInit) {
      if (y > lastY + threshold && y > 100) {
        header.classList.add('header--hidden');
      } else if (y < lastY - threshold) {
        header.classList.remove('header--hidden');
      }
    }

    // Compact style
    if (y > compactAt) header.classList.add('header--compact');
    else header.classList.remove('header--compact');

    lastY = y;
  }

  function onScroll() {
    applyState(window.scrollY);
    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(onScroll);
      ticking = true;
    }
  }

  // Enable on all devices
  window.addEventListener('scroll', requestTick, { passive: true });

  // Initial state check (don’t animate on load)
  header.classList.remove('header--hidden');
  applyState(window.scrollY, true);
})();


